import React from 'react'
import { isNil } from 'lodash'
import { useTranslation } from 'react-i18next';
import { DetailsContainer } from 'Components/shared/details-container';
import { FetchedUserData } from 'Types/user.types';
import { DataListType } from 'Types/common.types';

interface AttachmentsProps {
    userDetails:FetchedUserData;
}

const Attachments:React.FC<AttachmentsProps> = ({
    userDetails,
}) => {
    const { t } = useTranslation();

    const attachmentInfo: DataListType[] = [
        {
            label:t("label.nricPassport").toUpperCase(),
            value:userDetails.profile?.nric_passport?.fileName ?? '-',
            link:userDetails.profile?.nric_passport?.file_url ?? `#`
        },
    ]

    return (
        <>
            <DetailsContainer 
                listOfData={attachmentInfo}
            />
        </>
    )
}

export default Attachments